import Rete from 'rete';

import Check from './Check';
import { CHECK_INPUT_SOCKET, CHECK_OUTPUT_SOCKET } from '../SOCKETS';
import trackNodeHistory from '../utils/history/trackNodeHistory';

class CheckComponent extends Rete.Component {
  constructor(emitter) {
    super('Check');
    this.render = 'vue';
    this.data.component = Check;
    this.data.props = {};
    this.emitter = emitter;
  }

  builder = node => {
    const input = new Rete.Input('inputs', '', CHECK_INPUT_SOCKET, true);
    const yesOutput = new Rete.Output(
      'trueOutputs',
      'Yes',
      CHECK_OUTPUT_SOCKET,
      true,
    );
    const noOutput = new Rete.Output(
      'falseOutputs',
      'No',
      CHECK_OUTPUT_SOCKET,
      true,
    );

    node.addInput(input);
    node.addOutput(yesOutput);
    node.addOutput(noOutput);
    trackNodeHistory(this, node, this.emitter);
  };
}

export default CheckComponent;
